import { Component, Input, ChangeDetectionStrategy } from '@angular/core'

export type PillSize = 'm' | 's' | 'xs'
export type PillVariant = 'info' | 'success' | 'error' | 'warning' | 'neutral'

@Component({
  selector: 'lla-pill',
  templateUrl: './pill.component.html',
  styleUrls: ['./pill.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PillComponent {
  @Input() label = ''
  @Input() extraClass = ''
  @Input() selected = false
  @Input() hasHoverEffect = true
  @Input() size: PillSize
  // Semantic status color; leave unset for the default neutral chip look.
  @Input() variant?: PillVariant
}
